import { useEffect, useState } from "react";
import { Block, BlockHeader, BlockTitle, Button, List, ListItem, Navbar, Page, Preloader, Table, TableBody, TableCell, TableHead, TableRow } from "konsta/react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import lottieStep1 from "../lotties/All in one place-12Evv.json";
import lottieStep2 from "../lotties/Instant Access.json";
import lottieStep3 from "../lotties/Invest-NcSUa.json";
import lottieStep4 from "../lotties/Blockchain 2.json";
import lottieStep5 from "../lotties/Build Up Credit-vT40l.json";
import lottieStep6 from "../lotties/Earn as you learn-zarDx.json";

const steps = [
  {
    text: 'Welcome to MYNR!',
    subtitle: 'Start earning passive income with cloud-based crypto mining. No maintenance, no electricity costs—just profits! Let’s get you set up.',
    lottieData: lottieStep1,
    isLastStep: false
  },
  {
    text: 'Buy Your First Miner',
    subtitle: 'Head to the marketplace and choose a miner that fits your budget. Your miner will start earning as soon as it\'s activated!',
    lottieData: lottieStep2,
    isLastStep: false
  },
  {
    text: 'Track Your Earnings',
    subtitle: 'Monitor your daily, weekly, and monthly earnings in real time. Your profits are automatically added to your balance.',
    lottieData: lottieStep3,
    isLastStep: false
  },
  {
    text: 'Boost Earnings with Referrals',
    subtitle: 'Invite friends and earn up to 0.5% from their mining rewards. Share your referral link from the Profile page or by using /info in the bot.',
    lottieData: lottieStep4,
    isLastStep: false
  },
  {
    text: 'Withdraw Your Profits',
    subtitle: 'When you\'re ready, request a withdrawal, and your earnings will be sent directly to your wallet.',
    lottieData: lottieStep5,
    isLastStep: false
  },
  {
    text: 'Stay Updated',
    subtitle: 'Follow our channel for updates, new miners, and special promotions. Your journey to effortless mining starts now! ',
    lottieData: lottieStep6,
    isLastStep: true
  },
]

const HowPage = () => {
    const navigate = useNavigate()
    const [itemIndex, setItemIndex] = useState(0)
    const [step, setStep] = useState(steps[0])

    function nextPage() {
      setItemIndex(itemIndex + 1)
    }

    function prevPage() {
      setItemIndex(itemIndex - 1)
    }

    useEffect(() => {
      console.log(itemIndex)
      setStep(steps[itemIndex])
    }, [itemIndex])

    return (
      <Page className="select-none">        
        <div className="relative w-screen h-screen flex items-center justify-center">
            {/* Yellow Blur */}
            <div className="absolute top-20 left-20 w-64 h-64 bg-yellow-200 rounded-full blur-3xl opacity-50"></div>

            {/* Pink Blur */}
            <div className="absolute bottom-20 left-40 w-72 h-72 bg-pink-200 rounded-full blur-3xl opacity-50"></div>

            {/* Light Green Blur */}
            <div className="absolute top-32 right-32 w-80 h-80 bg-green-200 rounded-full blur-3xl opacity-50"></div>

            {/* Main Box (Foreground) */}
            <div className="relative z-10">
            <div className="flex flex-col">
                <div className="flex justify-center">
                  <Lottie animationData={step.lottieData} className="w-full max-w-[500px] h-auto"/>
                </div>

                <Block>
                  <div className="text-center">
                    <h1 className="text-3xl font-bold">{step.text}</h1>
                    <div className="text-md mt-2">{step.subtitle}</div>
                    {!step.isLastStep && <>
                      <Button className="mt-5" colors={{fillBgMaterial: 'bg-white', textMaterial: 'text-black'}} onClick={() => nextPage()}>Continue</Button>
                      <div className="mt-2 cursor-pointer" onClick={() => navigate('/')}>Skip</div>
                    </>}
                    
                    {step.isLastStep && <>
                      <Button className="mt-5" onClick={() => navigate('/')}>Go to Home Page</Button>
                    </>}
                  </div>
                </Block>
              </div>
            </div>
          </div>
      </Page>
    );
  };
  
  export default HowPage;
  